// extracted by mini-css-extract-plugin
export default {"panel":"EditListingWizardTab_panel__ahSVh"};